export default function splitName(value: string): string[] {
  return value.replace(/\s+/g, ' ').trim().split(' ');
}
